/**
 * Below slick slider is implemented globally and works for all the pages.
 * Need to add following details to the slider wrapper.
 * Add "slick-carousel" class to wrapper element.
 * Add data-sm="4" data-md="4" attributes to wrapper --> Number of slides to display
 * Add data-scrollsm="1" data-scrollmd="1" attributes to wrapper --> Number of slides to scroll on each Prev / Next click.
 * Note: Number of slides and slides to scroll can be changed for each breakpoint using addition data attributes.
 */

'use strict';

module.exports = function ($container) {
    let $slickCarousel = $container || $('body').find('.slick-carousel');

    const initSlickCarousel = function ($carousels) {
        $carousels.each(function() {
            let $thisCarousel = $(this);
            let data = $thisCarousel.data();
            const checkOptions = function (slides) {
                if (slides === 0) {
                    return true;
                } else {
                    return false;
                }
            }
            let carouselOptions = {
                infinite: data.infinite || false,
                slidesToShow: data.xxl || data.xl || data.lg || data.md,
                slidesToScroll: data.scrollxxl || data.scrollxl || data.scrolllg || data.scrollmd,
                dots: $thisCarousel.hasClass('indicators-md'),
                centerMode: data.mdcentermode || false,
                centerPadding: data.mdcenterpadding || 0,
                arrows: data.arrows || false,
                responsive: [
                    {
                        breakpoint: 1600,
                        settings: checkOptions(data.xl || data.lg || data.md) ? "unslick" : {
                            slidesToShow: data.xl || data.lg || data.md,
                            slidesToScroll: data.scrollxl || data.scrolllg || data.scrollmd
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: checkOptions(data.lg) ? "unslick" : {
                            slidesToShow: data.lg || data.md,
                            slidesToScroll: data.scrolllg || data.scrollmd
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: checkOptions(data.md) ? "unslick" : {
                            slidesToShow: data.md,
                            slidesToScroll: data.scrollmd
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: checkOptions(data.sm) ? "unslick" :  {
                            slidesToShow: data.sm || data.xs,
                            slidesToScroll: data.scrollsm || data.scrollxs,
                            dots: $thisCarousel.hasClass('indicators-sm'),
                            centerMode: data.smcentermode || false,
                            centerPadding: data.smcenterpadding || 0
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: checkOptions(data.xs) ? "unslick" :  {
                            slidesToShow: data.xs || data.sm,
                            slidesToScroll: data.scrollxs || data.scrollsm
                        }
                    }
                ]
            }
            // Slick moves the slides while (re)initialising, so refresh the wishlist icon state afterwards.
            $thisCarousel.off('init.wishlistIcon reInit.wishlistIcon').on('init.wishlistIcon reInit.wishlistIcon', function () {
                $('body').trigger('wishlist:reinitiateIcon');
            });
            !$thisCarousel.hasClass('slick-initialized') ? $thisCarousel.slick(carouselOptions): "";
            $(window).on("resize orientationchange", function() {
                $thisCarousel.hasClass('slick-initialized') ? $thisCarousel.slick('resize') : $thisCarousel.slick(carouselOptions);
            });
        });
    };

    initSlickCarousel($slickCarousel);

    // Einstein recommendation carousels on cart.isml (.einstein-recommendation) render
    // asynchronously and can appear after this module has already run once, so the
    // ".slick-carousel" elements inside them aren't there yet at line 13. Poll until
    // the Einstein carousel markup (.einstein-cards-carousel) shows up, then re-read
    // $slickCarousel and initialize whatever is newly available.
    if ($('.einstein-recommendation').length) {
        var einsteinCarouselInterval = setInterval(function() {
            if ($('.einstein-cards-carousel').length) {
                $slickCarousel = $container || $('body').find('.slick-carousel');
                initSlickCarousel($slickCarousel.not('.slick-initialized'));
                clearInterval(einsteinCarouselInterval);
            }
        }, 200);
    }
};
